import React, {Component} from 'react'
import {Card} from "react-bootstrap";
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import * as PropTypes from "prop-types";
import MainCard from "./MainCard";
import Image from "react-bootstrap/Image";
import VideoPlayerModal from "../modals/VideoPlayerModal";
import RecentAddedVideosModal from "../../pages/dashboard/modals/RecentAddedVideosModal";

/**
 * The component that displays recent added videos.
 */
class RecentAddedVideos extends MainCard {
    /**
     * Wrap video items within carousel.
     * @returns {React.ReactNode} The wrapped items.
     */
    wrapItemsWithContainer = (items) => {
        return (
            <Carousel slidesPerPage={5} itemWidth={250} offset={24} className="recent-added-videos-container">
                {items}
            </Carousel>
        );
    };

    /**
     * Render RecentAddedVideosItem components from data object.
     * @returns {React.ReactNode} The RecentAddedVideosItem components.
     */
    renderItemsFromData = () => {
        return this.props.data.map((rowData, index) => (
            // Mapping object data to children components.
            <RecentAddedVideosItem key={index} avatar={rowData.avatar} thumbnail={rowData.thumbnail} name={rowData.name} description={rowData.description}/>
        ));
    };

    /**
     * Remove footer component.
     */
    renderFooter = () => null;

    static propTypes = {
        // The text that will appear in the header.
        title: PropTypes.string.isRequired,
        // The text that will appear in the footer.
        footerText: PropTypes.string,
        // The link of see more page.
        footerLink: PropTypes.string,
    };
    static defaultProps = {
        title: "Recent Added Videos",
        footerText: "",
        footerLink: ""
    };
}

/**
 * The row component of ScoutingInvites.
 */
class RecentAddedVideosItem extends Component {

    constructor(props) {
        super(props);

        // TODO Handle state
        this.state = {
            popup: false,
        };

        this.setShow = this.setShow.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    render = () => {
        const {avatar, thumbnail, name, description} = this.props;
        const {popup} = this.state;
        const {setShow, handleClick} = this;

        return (
            <React.Fragment>
                <Card className="recent-added-videos-item" onClick={handleClick}>
                    <Card.Body className="recent-added-videos-item-body">
                        <Card.Img src={thumbnail}/>
                        <Card.ImgOverlay className="card-overlay">
                            <div className="card-overlay-container">
                                <div className="card-video-play-container">
                                    <div className="card-video-play rounded-circle">
                                        <i className="card-video-play-icon fas fa-play"> </i>
                                    </div>
                                </div>
                                <div className="card-caption">
                                    <div className="caption-avatar-container">
                                        <Image className="caption-avatar" roundedCircle={true} src={avatar}/>
                                    </div>
                                    <div className="caption-text-container">
                                        <div className="caption-title"> {name} </div>
                                        <div className="caption-description"> {description} </div>
                                    </div>
                                </div>
                            </div>
                        </Card.ImgOverlay>
                    </Card.Body>
                </Card>

                <RecentAddedVideosModal title={name} description={description} avatar={avatar} show={popup} onHide={() => setShow(false)}/>
            </React.Fragment>
        );
    };

    setShow = (value) => {
        this.setState({
            ...this.state,
            popup: value,
        });
    };

    handleClick = (event) => {
        this.setShow(true);
    };


    static propTypes = {
        // The profile image of the player.
        avatar: PropTypes.string.isRequired,
        // The name of the player.
        name: PropTypes.string.isRequired,
        // The description of the player.
        description: PropTypes.string.isRequired,
    };
}


export {RecentAddedVideos, RecentAddedVideosItem};
